import React, { useContext } from 'react'
import { PropertyContext } from '../utils/PropertyContext'
import { isEmpty } from 'lodash'

const Layout = (props) => {
  const { property } = useContext(PropertyContext)
  if (isEmpty(property)) {
    return null
  }
  return <div className="h-full z-10">{props.children}</div>
}

export default Layout
